import React, { useContext } from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import LogoutHandler from './Components/LogoutHandler';
import EDPopover from '../../../../BaseComponents/Popover/EDPopover';
import {
  useFullscreenView,
  useIsExtraSmallScreen,
} from '../../../../Hooks/useFullscreenView';
import UserMenuView from './UserMenuView';
import Dialog from '../../../../BaseComponents/Dialog/EDDialog';
import { LoginStateContext } from '../../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';

interface IProps {
  disabled: boolean;
  singleRoutineEnabled: boolean;
  onLogoutClick?: () => void;
  open: boolean;
  anchorEl?: HTMLElement;
  onClose: () => void;
  closeMiscMenu: () => void;
  formHasChanged: boolean;
}

export interface IUserMenuProps extends IProps {
  sign: string;
  name: string;
  visibleUnits: string[];
  allUnitsVisible: boolean;
  allRolesVisible: boolean;
  handleLogout: () => void;
  fullscreen: boolean;
  showLogoutButton?: boolean;
}

const useStyles = makeStyles()((theme: Theme) => ({
  popover: {
    minWidth: '470px',
  },
}));

/**
  Kontroll som visar vem den aktuella användaren är och menyalternativ som är kopplade till användaren.
*/
const UserMenu: React.FC<React.PropsWithChildren<IUserMenuProps>> = props => {
  const { classes } = useStyles();
  return props.fullscreen ? (
    <Dialog
      open={props.open}
      title={'Profil'}
      onClose={props.onLogoutClick}
      footerActions={[{ onClick: props.onLogoutClick, label: 'Stäng' }]}
    >
      <UserMenuView {...props} />
    </Dialog>
  ) : (
    <EDPopover
      open={props.open}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      classes={{
        paper: classes.popover,
      }}
    >
      <UserMenuView {...props} />
    </EDPopover>
  );
};

const EnhancedUserMenu: React.FC<React.PropsWithChildren<IProps>> = props => {
  const fullscreen = useFullscreenView();
  const isSmallScreen = useIsExtraSmallScreen();
  const loginStateContext = useContext(LoginStateContext);
  return (
    <LogoutHandler>
      {handleLogout => {
        const visibleUnits = loginStateContext.databases.map(x => x.name);

        return (
          <UserMenu
            visibleUnits={visibleUnits}
            allRolesVisible={false}
            allUnitsVisible={false}
            name={loginStateContext.name}
            sign={loginStateContext.sign}
            handleLogout={handleLogout}
            fullscreen={fullscreen}
            showLogoutButton={!isSmallScreen}
            {...props}
          />
        );
      }}
    </LogoutHandler>
  );
};

export default EnhancedUserMenu;
